module.exports = __webpack_public_path__ + "static/media/landingPage.e8e41cbd.jpg";